import { createApp } from "vue";
import Result from "./Result.vue";
import VueLazyLoad from "vue3-lazyload";
import consts from "@/const/const";
import "@/assets/js/scrollFilter";
import "@/assets/styles/app.scss";

const app = createApp(Result);
app.use(VueLazyLoad, {
  preLoad: 1.3,
  loading: consts.yumenaviinfo + "tm_web/common/images/image_holder.png",
  attempt: 1,
});
app.mount("#app");
